export const LogoutPath = '/logout';
export const LoginPath = '/login';
export const RedirectSearchParamName = 'path';
